import React, { useEffect, useState } from "react";
import QuestionTabs from "./LeadsTabs";
import PaginationNew from "../common/Pagination";
import api from "../../seller-apis/api";
import { fetchansQA, fetchunansQA } from "../../seller-apis/apidataField";
import SubmitAnswerModal from "../common/SubmitAnswerModal";
import { Actions } from "../../Actions/Actions";
import { useDispatch } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
var filterData = {};

function LeadsManagement(props) {
  return (
    <>
      <div className="lead-management-container">
        <div className="row align-top">
          <div className="col-md-4">
            <div className="wallet-container">
              <div className="back-container">
                <div className="content">
                  <div className="title">
                    Wallet Details
                    <hr />
                  </div>
                  <div className="amt dis-flex">
                    <div className="amt-data">
                      <div className="title">Utilized</div>
                      <div className="amount">&#8377;249</div>
                    </div>
                    <div className="amt-data">
                      <div className="title">Current</div>
                      <div className="amount">&#8377;0</div>
                    </div>
                  </div>
                  <div className="lead-action-buttons text-right">
                    <button>&#8377; Add Money</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="new-lead-container">
              <div className="heading dis-flex">
                <div className="title">
                  New leads
                  <hr />
                </div>
                <div className="lead-count">Total Pending - 2</div>
              </div>
              <div className="content dis-flex">
                <div className="lead-details">
                  <div className="prod-name">
                    Organic Cold Pressed, Water Soluble, Pure Neem Oil Pouch for
                    Plant
                  </div>
                  <div className="sku">Sku - SI-TP-2023</div>
                  <div className="quantity">Quantity : 1</div>
                  <div className="location">Durgapur</div>
                </div>
                <div className="lead-action-buttons text-right">
                    <button>Unlock</button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
          <table className="w-100 new-table-design">
          <tr>
            <th style={{ width: "10%" }}>Date</th>
            <th style={{ width: "15%" }}>Lead Converted</th>
            <th style={{ width: "15%" }}>Total leads generated</th>
            <th style={{ width: "12%" }}>Leads unlocked</th>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadsManagement;
